var navInit;

(function ($) {

	const selectors = {
		navContainer: '.c-nav, .c-top-nav',
		langDropdown: '[data-lang-dropdown]',
		langDropdownTrigger: '[data-lang-dropdown-trigger]',
	}

	navInit = function () {
		$(selectors.navContainer).each((i, el) => {
			new Nav(el);
		});
	}

	class Nav {
		constructor(element) {
			this.$container = $(element);

			this.init();
			this.bind();

		}
		init() {
			this.$items = $(this.$container).find('li');
			this.$items.filter((i, el) => {
				return ($(el).children('.sub-menu').children().length > 0);
			}).append('<div class="c-nav__item-arrow">');

			this.$langDropdown = $(selectors.langDropdown);
			this.$langDropdownTrigger = $(selectors.langDropdownTrigger);

		}

		bind() {
			const self = this;
			this.onHover = this.onHover.bind(this);
			this.onHoverOut = this.onHoverOut.bind(this);
			this.$items.hover(function (e) { self.onHover(this); }, function (e) { self.onHoverOut(this); });

			// this.$langDropdownTrigger.on('click', this.onlangDropdownTriggerClick.bind(this));
		}

		onHover(menuItem) {
			if ($(window).width() >= 900)
				$(menuItem).children('.sub-menu').stop().fadeIn();
		}

		onHoverOut(menuItem) {
			if ($(window).width() >= 900)
				$(menuItem).children('.sub-menu').stop().fadeOut();
		}

		onlangDropdownTriggerClick() {
			this.$langDropdown.toggle();
		}

	}

})(jQuery);


export default navInit;